import { render, staticRenderFns } from "./CockpitPieComponent.vue?vue&type=template&id=1a00fde9"
import script from "./CockpitPieComponent.vue?vue&type=script&lang=js"
export * from "./CockpitPieComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports